import { authorizedEdgeFetch } from 'app/axios/edge'

// applied = true for used codes and false for available codes

export interface FetchLicensesParams {
  applied: boolean
  relevant: boolean
  withCapabilities: boolean
}

export const fetchLicenses = (domainId: string, params: FetchLicensesParams) =>
  authorizedEdgeFetch.get(`/rms/domains/${domainId}/licenses`, { params })

export interface UpdateLicenseNotePayload {
  notes: string
}

export const updateLicenseNote = (
  domainId: string,
  licenseId: number,
  payload: UpdateLicenseNotePayload
) =>
  authorizedEdgeFetch.put(
    `/rms/domains/${domainId}/licenses/${licenseId}`,
    payload
  )

export interface ImportLicensePayload {
  domainId: string
  code: string
}

export const importLicense = ({ domainId, code }: ImportLicensePayload) =>
  authorizedEdgeFetch.put(
    `rms/domains/${domainId}/licenses/import?code=${code}`
  )

export interface ReclaimLicensePayload {
  domainId: string
  licenseId: number
  rootDomainId: string
}

export const reclaimLicense = ({
  domainId,
  licenseId,
  rootDomainId,
}: ReclaimLicensePayload) =>
  authorizedEdgeFetch.put(
    `rms/domains/${domainId}/licenses/${licenseId}/reclaim`,
    {
      id: rootDomainId,
    }
  )

// id is target dealer's id
export interface TransferLicenseBody {
  id: string
}

export function transferLicense(
  purchaserDomainId: string,
  licenseId: number,
  body: TransferLicenseBody
) {
  return authorizedEdgeFetch.put(
    `rms/domains/${purchaserDomainId}/licenses/${licenseId}/transfer`,
    body
  )
}
